const filmLocationRouter = {
  route: null,
  name: null,
  title: '出海服务',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-school',
  filePath: 'view/overseas_services/', // 文件路径
  order: 20,
  inNav: true,
  permission: ['海外发行列表'],
  children: [
    {
      title: '海外发行列表',
      type: 'view',
      name: 'overseasServicesList',
      route: '/overseasServices/list',
      filePath: 'view/overseas_services/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['海外发行列表'],
    },
    {
      title: '新增海外发行',
      type: 'view',
      name: 'addOverseasServices',
      route: '/overseasServices/add',
      filePath: 'view/overseas_services/create.vue',
      inNav: true,
      icon: 'iconfont el-icon-document-add',
      permission: ['新增海外发行'],
    },
  ],
}

export default filmLocationRouter
